import { render, staticRenderFns } from "./PatSignUp.vue?vue&type=template&id=24d08074"
import script from "./PatSignUp.vue?vue&type=script&lang=js"
export * from "./PatSignUp.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports